<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: left">
            <el-button
              v-access:add
              icon="el-icon-plus"
              @click="add"
              size="small"
              :disabled="isloading"
              type="danger"
              >新增</el-button
            >
          </div>
          <div style="float: right">
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchModel.searchKey"
              clearable
              :placeholder="placeholder"
            />
            <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="search"
              >查询</el-button
            >
          </div>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="Id"
            label="单号"
            align="left"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="ProjectName"
            label="实施项目"
            align="left"
            :formatter="IsProjectName"
          ></el-table-column>
          <el-table-column
            prop="RecipientType"
            label="受赠者类型"
            :formatter="formaRecipientType"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="Source"
            label="资金来源"
            align="center"
            :formatter="formatterStatus"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="Amount"
            label="支出金额"
            align="right"
            :show-overflow-tooltip="true"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="RecipientName"
            label="受赠者"
            align="left"
            width="250"
          ></el-table-column>
          <el-table-column label="支出时间" align="center" width="140">
            <template slot-scope="scope">
              {{ (scope.row.FinishTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:read
                @click="innerRead(scope.row)"
                type="text"
                size="mini"
                >详情</el-button
              >
              <el-button
                v-access:delete
                v-if="scope.row.IsManualEntry"
                @click="innerDel(scope.row)"
                type="text"
                size="mini"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit>
    <ModuleQuery
      v-if="formDataQuery"
      :dataForm="formData"
      @formCallBack="formCallBack"
    ></ModuleQuery>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleEdit from "@/modules/zjrc/pages/capital/expenditure/edit";
import ModuleQuery from "@/modules/zjrc/pages/capital/expenditure/query";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formDataQuery: false,
      formTitle: "",
      formData: {},

      total: 0,
      currentPage: 1,
      pageSize: 15,

      //搜索字段
      searchModel: {
        status: "",
        searchKey: "",
      },
      placeholder: "请输入单号 / 实施项目 / 受赠者",
    };
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleEdit,
    ModuleQuery,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    this.loadData();
  },
  methods: {
    search(){
      const vm = this
      vm.currentPage = 1
      vm.loadData()
    },
    //初始化数据
    loadData() {
      this.isloading = true;
      let params = {
        PageIndex: this.currentPage,
        PageSize: this.pageSize,
        keyWord: this.searchModel.searchKey,
      };
      api.QueryCapitalExpenditure(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          var data = rep.data.Data.rows;
          this.listData = data;
        }
        this.isloading = false;
      });
    },
    //新增
    add() {
      this.formTitle = "新增资金支出";
      this.formData = {};
      api.GetIncomeIndexCapitalIncome().then((rep) => {
        if (rep.data.Code === 0) {
          this.formData.IncomeCode = rep.data.Data;
          this.formData.CreateUserName = this.GetCurrentUserInfo.RealName;
          this.formVisible = true;
        }
      });
    },
    //查看详情
    innerRead(rowData) {
      this.formData = Object.assign({}, rowData);
      this.formDataQuery = true;
    },
    formCallBack(data) {
      this.formVisible = false;
      this.formDataQuery = false;
      if (data != null) {
        this.loadData();
      }
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 280;
      }
      return tableMaxHeight;
    },
    //状态
    formatterStatus(item) {
      switch (item.Source) {
        case 0:
          return "社会捐赠 ";
        case 1:
          return "财政拨款";
        case 2:
          return "其他";
      }
    },
    IsProjectName(rowData) {
      return rowData.ProjectName ? rowData.ProjectName : "-";
    },
    //展示受赠者类型
    formaRecipientType(item) {
      switch (item.RecipientType) {
        case 0:
          return "个人 ";
        case 1:
          return "企业";
        case 2:
          return "单位";
      }
    },
    //删除
    innerDel(rowData) {
      this.$confirm("请确认是否删除选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api
          .DeleExpendCapitalExpenditure(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentPage = 1;
              this.loadData();
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
    },
  },
};
</script>

<style scoped>
.list-form {
  padding: 20px;
  box-sizing: border-box;
  float: left;
  overflow: auto;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-select >>> .el-input__inner {
  width: 3rem;
}
.el-row >>> .el-date-editor {
  width: 2.5rem !important;
}
</style>
